import { faSpinner } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { PRODUCT_TYPES } from '@moal/api'
import { useContext } from 'react'
import { SiteConfigContext } from '../../context/siteConfigContext'

export default function CookiePolicyText() {
  const { productsService } = useContext(SiteConfigContext)
  if (!productsService)
    return (
      <div className="flex justify-center items-center h-screen bg-white p-8 prose dark:prose-invert mx-auto">
        <FontAwesomeIcon icon={faSpinner} spin size="3x" />
      </div>
    )
  const org = productsService[PRODUCT_TYPES.ORG]

  return (
    <article className="prose dark:prose-invert">
      <p>
        <strong>Cookie Policy</strong>
      </p>
      <p>Last updated: 10/01/2025</p>
      <p>
        <em>
          This is the cookie policy of {org.copyright} If we change our cookie
          policy, we will notify you of those changes here.{' '}
        </em>
      </p>
      <p>
        <strong>
          <u>What are cookies?</u>
        </strong>
      </p>
      <p>
        As is common practice with almost all professional websites, this
        Website uses cookies and other tracking devices to improve your
        experience. Cookies, which are tiny pieces of data downloaded to your
        computer or mobile device, are essential to the effective operation of
        our Website, and if you are a subscriber of our paid services, for you
        to view the members’ only content. Cookies on this Website also help to
        tailor the products and services offered and advertised to our customers
        on this Website and elsewhere.
      </p>
      <p>
        Cookies set by us are called “first party cookies”. Cookies set by
        parties other than us are called “third party cookies”. Third party
        cookies enable third party features or functionality to be provided on
        or through the Website (such as advertising, interactive content and
        analytics). The third parties that set these third party cookies can
        recognise your computer both when it visits the Website in question and
        also when it visits certain other websites or services.
      </p>
      <p>
        This page describes what information they gather, how we use it and why
        we sometimes need to store these cookies.
      </p>
      <p>
        We will also share how you can prevent these cookies from being stored
        although this may downgrade or ‘break’ certain elements of the Website’s
        functionality.
      </p>
      <p>
        For more general information on cookies,{' '}
        <a
          href="http://en.wikipedia.org/wiki/HTTP_cookie"
          data-url="http://en.wikipedia.org/wiki/HTTP_cookie"
          target="_blank"
          rel="noopener noreferrer"
        >
          see this article on HTTP cookies
        </a>
        .
      </p>
      <p>
        <strong>
          <u>How we use cookies</u>
        </strong>
      </p>
      <p>We use cookies for a variety of reasons detailed below.</p>
      <p>
        Also, from time to time we test new features or offers and make subtle
        changes to the way that the Website is delivered. When we are testing
        new features, test cookies may be used to ensure that you receive a
        consistent experience whilst on the Website and to allow us to
        understand which optimisations our users appreciate the most.
      </p>
      <p>
        We also use social media buttons and/or plugins on this Website that
        allow you to connect with your social network in various ways. For these
        to work social media websites including Facebook, twitter, google+, and
        stumble upon, will set cookies through our Website which may be used to
        enhance your profile on their website or contribute to the data they
        hold for various purposes outlined in their respective privacy policies.
      </p>
      <p>
        Unfortunately, in most cases there are no industry standard options for
        disabling cookies without completely disabling the functionality and
        features they add to this Website. It is recommended that you leave on
        all cookies if you are not sure whether you need them or not, in case
        they are needed to provide a service that you use.
      </p>
      <p>
        <strong>
          <u>The cookies we set</u>
        </strong>
      </p>
      <p>
        If you are a subscriber with us then we will use cookies for the
        management of the signup process and general administration. These
        cookies will usually be deleted when you log out, however in some cases
        they may remain afterwards to remember your site preferences when logged
        out.
      </p>
      <p>
        We use cookies when you are logged in so that we can remember this fact.
        This prevents you from having to log in every single time you visit a
        new page. These cookies are typically removed or cleared when you log
        out to ensure that you can only access restricted features and areas
        when logged in.
      </p>
      <p>
        Cookies may be used to remember if you are already registered and
        whether to show certain notifications which might only be valid to
        subscribed/unsubscribed users.
      </p>
      <p>
        Our Website offers e-commerce or payment facilities and some cookies are
        essential to ensure that your order is remembered between pages so that
        we can process it properly.
      </p>
      <p>
        From time to time, we offer user surveys and questionnaires to provide
        you with interesting insights, helpful tools, or to understand our
        subscribers more accurately. These surveys may use cookies to remember
        who has already taken part in a survey or to provide you with accurate
        results after you change pages.
      </p>
      <p>
        When you submit data to us through a form such as those found on contact
        pages or comment forms cookies may be set to remember your user details
        for future correspondence.
      </p>
      <p>
        In order to provide you with a great experience we provide the
        functionality to set your preferences for how this Website runs when you
        use it. In order to remember your preferences we need to set cookies so
        that this information can be called whenever you interact with a page on
        the Website.
      </p>
      <p>
        The specific types of cookies served through our Website are described
        below:
      </p>
      <p>
        <strong>
          <u>Cookie List</u>
        </strong>
      </p>
      <div id="ot-sdk-cookie-policy"></div>
      <p>
        <strong>
          <u>Disabling Cookies</u>
        </strong>
      </p>
      <p>
        Cookies help you to get the most out of our Website. If you disable the
        cookies you may find that certain sections of our Website don’t work at
        all (for example, you may have difficulty viewing subscription only
        articles) or don’t work as well as you have come to expect. However, in
        case you want to disable cookies, you have the following options:
      </p>
      <p>
        Website Cookie Preference Tool: You can exercise preferences about what
        cookies are served on our Website by visiting our cookie settings
        preference centre. You can also exercise your Website cookie preferences
        by visiting the TRUSTe preference centre by clicking this link:{' '}
        <a
          href="http://preferences-mgr.truste.com/"
          data-url="http://preferences-mgr.truste.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          http://preferences-mgr.truste.com/
        </a>
      </p>

      <button id="ot-sdk-btn" className="ot-sdk-show-settings">
        Cookie Settings
      </button>

      <p>
        Browser Controls: You can set or amend your web browser controls to
        accept or refuse cookies. If you choose to reject cookies, you may still
        use our Website though your access to some functionality and areas of
        our Website may be restricted. As the means by which you can refuse
        cookies through your web browser controls vary from browser-to-browser,
        you should visit your browser’s help menu for more information.
      </p>
      <p>
        Global Privacy Control and Do Not Track signals: Some Internet browsers
        – like Internet Explorer, Firefox, and Safari – include the ability to
        transmit a “Global Privacy Control” or “GPC” signal, and “Do Not Track”
        or “DNT” signals. We honour GPC and DNT signals. To learn more about
        “GPC” signals, please visit the{' '}
        <a
          href="https://globalprivacycontrol.org/"
          data-url="https://globalprivacycontrol.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Global Privacy Control website
        </a>
        . To learn more about “DNT”, please visit{' '}
        <a
          href="https://allaboutdnt.com/"
          data-url="https://allaboutdnt.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          All About Do Not Track
        </a>
        .
      </p>
      <p>
        If you have opted out of cookies used for targeted advertising or the
        sale of your personal information, you may wish to clear any existing
        cookies from your browser. Below are instructions on how to do this for
        various popular browsers:<strong>Google Chrome:</strong>
      </p>
      <ol type="1">
        <li>
          Open Chrome and click on the three dots in the upper right corner.
        </li>
        <li>
          Select <strong>Settings</strong>.
        </li>
        <li>
          Click on <strong>Privacy and security</strong>.
        </li>
        <li>
          Choose <strong>Clear browsing data</strong>.
        </li>
        <li>
          In the dialog that appears, select{' '}
          <strong>Cookies and other site data</strong> and choose the time
          range.
        </li>
        <li>
          Click <strong>Clear data</strong>.
        </li>
      </ol>
      <p>
        <strong>Mozilla Firefox:</strong>
      </p>
      <ol type="1">
        <li>
          Open Firefox and click on the three horizontal lines in the upper
          right corner.
        </li>
        <li>
          Select <strong>Settings</strong>.
        </li>
        <li>
          Go to <strong>Privacy & Security</strong>.
        </li>
        <li>
          Under <strong>Cookies and Site Data</strong>, click on{' '}
          <strong>Clear Data...</strong>.
        </li>
        <li>
          Ensure <strong>Cookies and Site Data</strong> is checked, then click{' '}
          <strong>Clear</strong>.
        </li>
      </ol>
      <p>
        <strong>Safari (Mac):</strong>
      </p>
      <ol type="1">
        <li>
          Open Safari and click on <strong>Safari</strong> in the menu bar.
        </li>
        <li>
          Select <strong>Preferences</strong>, then go to the{' '}
          <strong>Privacy</strong> tab.
        </li>
        <li>
          Click on <strong>Manage Website Data...</strong>.
        </li>
        <li>
          You can either remove specific cookies or click{' '}
          <strong>Remove All</strong> to delete all cookies.
        </li>
      </ol>
      <p>
        <strong>Microsoft Edge:</strong>
      </p>
      <ol type="1">
        <li>
          Open Edge and click on the three dots in the upper right corner.
        </li>
        <li>
          Select <strong>Settings</strong>, then go to{' '}
          <strong>Privacy, search, and services</strong>.
        </li>
        <li>
          Under <strong>Clear browsing data</strong>, click on{' '}
          <strong>Choose what to clear</strong>.
        </li>
        <li>
          Select <strong>Cookies and other site data</strong>, then click{' '}
          <strong>Clear now</strong>.
        </li>
      </ol>
      <p>
        For other browsers or more detailed instructions, please refer to your
        browser's help section.
      </p>
      <p>
        If you would like to learn more about cookies in general, or how to
        disable targeted advertising cookies, you can visit{' '}
        <a
          href="http://www.youronlinechoices.eu/"
          data-url="http://www.youronlinechoices.eu/"
          target="_blank"
          rel="noopener noreferrer"
        >
          http://www.youronlinechoices.eu/
        </a>
        .
      </p>
      <p>
        <strong>
          <u>Links to other websites</u>
        </strong>
      </p>
      <p>
        Our Website may include hyperlinks to other websites that are not
        operated or controlled by us. This cookie policy only applies to our
        Website and we are not responsible for the content or the privacy and
        cookie practices of third party websites.
      </p>
      <p>
        <strong>
          <u>Updates to this cookie policy</u>
        </strong>
      </p>
      <p>
        We may update this cookie policy from time to time in response to
        changing legal, technical or business developments. When we update our
        cookie policy, we will take appropriate measures to inform you,
        consistent with the significance of the changes we make.
      </p>
      <p>
        You can see when this cookie policy was last updated by checking the
        “last updated” date displayed at the top of this policy.
      </p>
      <p>
        <strong>
          <u>How to contact us</u>
        </strong>
      </p>
      <p>
        If you have any questions or concerns about our use of your personal
        information, please contact us by clicking{' '}
        <a href={org.contactUs} target="_blank" rel="noreferrer">
          here
        </a>
      </p>
    </article>
  )
}
